import { Component, OnInit } from '@angular/core';
// import { Adal5Service } from 'adal-angular5';
 
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
 
  isAuthenticated = false;
 
  constructor() {
    // this.isAuthenticated = this.adalSvc.userInfo.authenticated;
  }
 
  ngOnInit() {
    localStorage.removeItem('currentUser');
    if (this.isAuthenticated) {
      // this.adalSvc.logOut();
    }
  }
}